import { useTripsBulkRejectReasonsCreateQuery } from '@bambi/api-client/trips';
import { useMemo } from 'react';

import { useAppSelector } from 'src/app/store/hooks';

// Sorted so every row (and the global menu) produces the same query arg and
// RTK Query dedupes them into a single request per modal.
export function useRejectTripIds() {
  const requestedTripIdsToRejectToReasonCodes = useAppSelector(
    (state) => state.dispatcher.modals.requestedTripIdsToRejectToReasonCodes
  );
  return useMemo(
    () => Object.keys(requestedTripIdsToRejectToReasonCodes).sort(),
    [requestedTripIdsToRejectToReasonCodes]
  );
}

export function useRejectionReasonOptions(tripId: string) {
  const tripIds = useRejectTripIds();
  return useTripsBulkRejectReasonsCreateQuery(
    { bulkTripRejectReasonsWritable: { trip_ids: tripIds } },
    {
      skip: tripIds.length === 0,
      selectFromResult: (result) => ({
        // Distinguishes loading from loaded-but-empty: the backend returns
        // an empty list for trips that can no longer be rejected.
        isLoading: result.data === undefined,
        options: (
          result.data?.results.find((r) => r.trip_id === tripId)
            ?.rejection_reasons ?? []
        ).map((reason) => ({
          label: reason.label,
          value: reason.value || '',
        })),
      }),
    }
  );
}
